import { CatalogPageQuerykeys } from '@enums/react-query-keys';
import { CatalogGuidedSearchResponse } from '@interfaces/api/responses/catalog-page-guided-search-response';
import { CatalogContext } from '@context/catalog.context';
import { useContextSelector } from 'use-context-selector';

import { useQuery } from '@tanstack/react-query';

type UseGuidedSearchQueryType = {
  guidedSearch: CatalogGuidedSearchResponse;
  showCarousel: boolean;
};

const useGuidedSearchQuery = (): UseGuidedSearchQueryType => {
  const { data: guidedSearch } = useQuery<CatalogGuidedSearchResponse>({
    queryKey: [CatalogPageQuerykeys.GET_GUIDED_SEARCH],
    staleTime: Infinity,
  });

  const isStaticGuidedSearchDisabled = useContextSelector(
    CatalogContext,
    (v) => v.isStaticGuidedSearchDisabled ?? false,
  );

  const showCarousel = !isStaticGuidedSearchDisabled && guidedSearch?.items?.length > 0;

  return {
    guidedSearch,
    showCarousel,
  };
};
export default useGuidedSearchQuery;
